import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 1.08h2.52a.48.48 0 0 1 .48.48v9.96a.48.48 0 0 1-.48.48H.48a.48.48 0 0 1-.48-.48V1.56a.48.48 0 0 1 .48-.48H3V.12A.12.12 0 0 1 3.12 0h.84a.12.12 0 0 1 .12.12v.96h3.84V.12A.12.12 0 0 1 8.04 0h.84A.12.12 0 0 1 9 .12zm-7.92 9.84h9.84v-5.7H1.08zm0-8.76V4.2h9.84V2.16H9v.72a.12.12 0 0 1-.12.12h-.84a.12.12 0 0 1-.12-.12v-.72H4.08v.72a.12.12 0 0 1-.12.12h-.84A.12.12 0 0 1 3 2.88v-.72zm8.253 4.507H6.667v2.666h2.666z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }